<script>
import noChat from '../../../../../fianly/assets/no-chat.svg';
import FeaturePlaceholder from './FeaturePlaceholder.vue';
export default {
  components: { FeaturePlaceholder },
  props: {
    message: {
      type: String,
      required: true,
    },
  },
  setup() {
    return { noChat };
  },
};
</script>

<template>
  <div class="flex flex-col items-center justify-center h-full">
    <img class="m-4 w-48" :src="noChat" alt="" />
    <span class="text-sm text-n-slate-12 font-medium text-center">
      {{ message }}
      <br />
    </span>
    <!-- Cmd bar, keyboard shortcuts placeholder -->
    <FeaturePlaceholder />
  </div>
</template>
